import React, {Component} from "react"

export default class CustomIcon extends Component {
  render() {
    return <img src={this.props.i} alt={"Icon (" + this.props.i + ")"} />
  }
}



// WEBPACK FOOTER //
// ./src/components/decorators/CustomIcon.js